import CheckboxViolet from "@UI/New/ChecboxViolet/CheckboxViolet";
import classNames from "classnames";
import s from "./checkboxEmpty.module.css"

const CheckboxEmpty = ({
    value,
    disabled,
    className = false,
    ...props
}) => {
    return <CheckboxViolet
        value={value}
        className={classNames(s.checkboxViolet, {[className]: !!className})}
        blockClassName={classNames({
            [s.checkboxColor]: value},
            {[s.checkboxBlock]: !disabled},
            {[s.checkboxBlockDisabled]: disabled}
        )}
        textClassName={s.checkboxText}
        noCheckImg={disabled && !value}
        { ...props }
    />;
}

export default CheckboxEmpty;